import {
  Backdrop, Button, Card, CardActions, CardContent,
  CardHeader, Divider, Modal, CircularProgress,
  ImageListItem, ImageList, IconButton, ImageListItemBar
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { openBlob } from 'src/utils/Common';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import axios from 'src/utils/axios';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  rootCCFile: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  actionsCCFile: {
    justifyContent: 'flex-end'
  }
}));

function CCFilePopup({ open, onClose, FisNo, className }) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [CCFileData, setCCFileData] = useState([]);
  const handleCCFileDetayAc = (event, Id, Type) => {
    setLoading(true);
    const config = {
      responseType: 'blob',
    };
    axios.get('/FileImportExport/ArtemisCCFileDetail/' + FisNo + '/' + Id + '/' + Type, config)
      .then(response => {
        openBlob(response.data, Id);
        setLoading(false);
      }).catch(() => {
        setLoading(false);
      });

  };



  useEffect(() => {
    let mounted = true;

    const fetchTodos = () => {
      axios.get('/GetCCMainFile/' + FisNo).then(response => {
        if (mounted) {
          const Deger = response.data === "" ? [] : response.data;
          setCCFileData(Deger);
          setLoading(false);
        }
      }).catch(() => {
        setLoading(false);
      });
    };
    fetchTodos();
    return () => {
      mounted = false;
    };
  }, [FisNo]);

  if (!open) {
    return null;
  }

  return (
    <Modal
      onClose={() => { onClose() }}
      open={open}
    >
      <Card
        className={clsx(classes.rootCCFile, className)}
      >
        <CardHeader title={"Çağrı Merkezi Dosyalar"} />
        <Divider />
        <CardContent className={classes.content}>
          {
            loading ?
              <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color="inherit" />
              </Backdrop>
              : ""
          }
          <ImageList rowHeight={120} className={classes.gridList}>
            {CCFileData.map((item) => (
              <ImageListItem
                key={item.attachmentId}
              >
                <IconButton
                  onClick={(event) => handleCCFileDetayAc(event, item.attachmentId, item.objectType)} aria-label={`büyük resim ${item.name}`}
                >
                  {/* <img src={getImgDetay(item.attachmentId, item.objectType)} alt={item.name} /> */}
                  <PhotoLibraryIcon />
                </IconButton>
                <ImageListItemBar
                  title={item.name}
                  subtitle={<span>{item.contentType}</span>}
                />
              </ImageListItem>
            ))}
          </ImageList>
        </CardContent>
        <Divider />
        <CardActions className={classes.actionsCCFile}>
          <Button
            variant="contained"
            color="secondary"
            endIcon={<CloseIcon>Close</CloseIcon>}
            onClick={() => { onClose() }}>
            Kapat
          </Button>
        </CardActions>
      </Card>
    </Modal>
  );
}

CCFilePopup.defaultProps = {
  open: false,
  onClose: () => { }
};

export default CCFilePopup;
